import React from 'react'
import { connect } from 'react-redux'
import { MessageCenter } from '../../components/MessageCenter'
import { RootState } from '../../store'
import { TradeSubmissionDetails } from '../../types'
import { formatCentralDateToEastern } from '../../utils/dateUtil'

const TradeSubmissionSuccessToaster = ({
  successMessage,
  tradeSubmissionDetails,
}: {
  successMessage?: string
  tradeSubmissionDetails?: TradeSubmissionDetails
}) => {
  const getSubmissionDetails = ({
    accountNumber,
    correspondent,
    externalId,
    id,
    status,
    timestamp,
  }: TradeSubmissionDetails) => [
    `Account Number: ${accountNumber}`,
    `Correspondent: ${correspondent}`,
    `External ID: ${externalId}`,
    `ID: ${id}`,
    `Timestamp: ${formatCentralDateToEastern(timestamp)}`,
    `Status: ${status}`,
  ]

  return successMessage ? (
    <MessageCenter
      autoDismiss={false}
      successMessages={[successMessage].concat(
        tradeSubmissionDetails ? getSubmissionDetails(tradeSubmissionDetails) : []
      )}
    />
  ) : null
}

const mapStateToProps = (state: RootState) => {
  const {
    transactionReducer: { tradeSubmittedMessage, tradeSubmissionDetails },
  } = state
  return { successMessage: tradeSubmittedMessage, tradeSubmissionDetails }
}

export default connect(mapStateToProps)(TradeSubmissionSuccessToaster)
